import { createAction } from "@reduxjs/toolkit";

const actionTypes = {
 	getRanges : createAction("getRanges"),	
 	getDirectBonds : createAction("getDirectBonds"),	
	getDirectBondsMemberships: createAction("getDirectBondsMemberships"),
 	getPrizes : createAction("getPrizes"),	
}

export default actionTypes;